
import { useState } from "react";
import "./Hero.css"
import heroImage from "../assets/hero-image.svg";
import logo from "../assets/logo.png";
import cartIcon from "../assets/cart-icon.svg";
import searchIcon from "../assets/search-icon.svg";

import { heroTitle, heroSubtitle } from "../data";

import FadeIn from "../components/FadeIn";
import NavLink from "../components/NavLink";

// react icons
import { HiMenuAlt3 } from "react-icons/hi";
import { AiOutlineClose } from "react-icons/ai";

const Hero = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  return <div className="hero h-screen relative flex flex-col items-center">
    <FadeIn delay={0.2} direction="down" padding fullWidth>
        <h1 className="mt-32 font-bold text-center text-5xl leading-tight xs:text-[64px] text-white max-w-[1050px]">
          {heroTitle}
        </h1>
    </FadeIn>
    <FadeIn delay={0.4} direction="down" padding fullWidth>
        <h5 className="mt-6 text-center text-lg xs:text-xl text-white max-w-[500px]">
          {heroSubtitle}
        </h5>
    </FadeIn>
  </div>;
};

export default Hero;
